import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { Item } from 'src/app/models/item.model';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	private baseUserUrl = `${environment.baseUrl}/user`;

	constructor(
		private httpClient: HttpClient,
		private authService: AuthService
	) { }

	@ApiMethod()
	isVendor(token: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${this.baseUserUrl}/${token}/is-vendor`);
	}

	@ApiMethod()
	getRedirectUri(token: string): Observable<{ uri: string }> {
		return this.httpClient.get<{ uri: string }>(`${environment.baseUrl}/${token}`);
	}

	@ApiMethod()
	getAssigneeUsers(token: string): Observable<UserContactInfo[]> {
		return this.httpClient.get<UserContactInfo[]>(`${this.baseUserUrl}/${token}/assignees`);
	}

	@ApiMethod()
	getVendorUsers(token: string): Observable<UserContactInfo[]> {
		return this.httpClient.get<UserContactInfo[]>(`${this.baseUserUrl}/${token}/vendors`);
	}

	@ApiMethod()
	getCurrentUserDetails(token: string): Observable<Item<number, string>> {
		return this.httpClient.get<Item<number, string>>(`${this.baseUserUrl}/${token}/current-user`);
	}

	@ApiMethod()
	canConfigureRounds(token: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${this.baseUserUrl}/${token}/can-configure-rounds`);
	}

	@ApiMethod()
	getDeleteUserAccountRedirectUri(): Observable<{ smartSyncUri: string }> {
		return this.httpClient.get<{ smartSyncUri: string }>(`${this.baseUserUrl}/unregister-user/id-url`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	getDeleteUserAccountInfo(token: string): Observable<any> {
		return this.httpClient.get<any>(`${this.baseUserUrl}/${token}/delete-user-info`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	deleteUserAccount(token: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${this.baseUserUrl}/${token}/unregister-user`, { headers: this.authService.getAuthenticationHeader() });
	}
}
